var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1949 9.82798L6.50122 8.13712C5.95607 7.59287 5.95607 6.71048 6.50122 6.16623C6.98842 5.67985 7.04728 4.91134 6.63984 4.35665L5.24915 2.46343C4.83746 1.90296 4.02223 1.84072 3.52996 2.33217C2.7805 3.08039 2.27868 4.07059 2.338 5.12706C2.62781 10.2884 6.66549 13.7386 11.2317 13.9953C12.2788 14.0542 13.254 13.5486 13.9956 12.8082C14.4952 12.3094 14.4319 11.4834 13.8621 11.0663L11.9817 9.68959C11.4261 9.28282 10.6563 9.34159 10.1691 9.82798C9.62391 10.3722 8.74005 10.3722 8.1949 9.82798Z",
    stroke: "#808897",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLight);
export default __webpack_public_path__ + "static/media/phone-light.75b2af1641fd83e1122c2d7dcdeb681e.svg";
export { ForwardRef as ReactComponent };